import ImportHistory from './ImportHistory';

export default ImportHistory;
